export const sankey = {
    link: {
        style: {
            fillOpacity: .15,
            round: !0
        }
    }
};
//# sourceMappingURL=sankey.js.map
